import { defineMessages } from "react-intl";

export const messages = defineMessages({
  companyLogoAlt: {
    id: "rovo-extension.navigation.company-logo.alt",
    defaultMessage: "Company logo",
    description:
      "The text is used as the alt attribute for the company logo image shown in the top navigation bar of the Rovo new tab page when an organisation has configured their company branding.",
  },
  homeLabel: {
    id: "rovo-extension.navigation.home.label",
    defaultMessage: "Home",
    description:
      "The text is used as an aria-label or visible label for the Home navigation item in the top navigation bar of the Rovo extension, which takes the user back to the main new tab page.",
  },
  siteNavigationLabel: {
    id: "rovo-extension.navigation.site.label",
    defaultMessage: "site",
    description:
      "Label for site navigation component. Label is used for screenreaders only, not rendered in UI. Here, site refers to the Atlassian organization the user is on.",
  },
  siteIconLabel: {
    id: "rovo-extension.navigation.site-icon.label",
    defaultMessage: "site",
    description:
      "Label for site icon in site switcher. Label is used for screenreaders only, not rendered in UI. Here, site refers to the Atlassian organization the user is on. Icon is the ADS office building icon.",
  },
  appSwitcherTooltip: {
    id: "rovo-extension.navigation.app-switcher.tooltip",
    defaultMessage: "Switch to...",
    description:
      "The text is shown as a tooltip on the app switcher icon button in the top navigation bar of the Rovo extension, indicating that clicking it will allow the user to switch between Atlassian products.",
  },
});
